import Vue from 'vue';
import {indexOf, map} from 'lodash';
import {loadNewsletters, removeNewsletter} from '@/modules/ProjectModule/modules/CustomerModule/api/newsletter.api';

function initialState() {
    return {
        newsletters: [],
    }
}

const getters = {
    newsletters: (state) => state.newsletters,
}

const actions = {
    async init({ dispatch }) {
        dispatch('reset');
        return dispatch('loadnewsletters');
    },

    async loadNewsletters({ commit, rootGetters }) {
        const projectId = rootGetters['projects/project/projectId'];
        return loadNewsletters(projectId).then((data) => commit('SET_NEWSLETTERS', data))
    },
    async removeNewsletter({ commit }, newsletterId) {
        return removeNewsletter(newsletterId).then(() => commit('REMOVE_NEWSLETTER', newsletterId))
    },

    reset: ({ commit }) => commit('RESET'),
}

const mutations = {
    SET_NEWSLETTERS:   (state, newsletters) => state.newsletters = newsletters,
    UPDATE_NEWSLETTER: (state, data) => {
        const index = indexOf(map(state.newsletters, (object) => object.id), data.id);
        Vue.set(state.newsletters, index, data);
    },
    REMOVE_NEWSLETTER: (state, data) => {
        const index = indexOf(map(state.newsletters, (object) => object.id), data);
        if (index !== -1) {
            state.newsletters.splice(index, 1);
        }
    },

    RESET: (state) => {
        const s = initialState();
        Object.keys(s).forEach(key => state[key] = s[key]);
    }
}

export default {
    namespaced: true,
    state:      initialState,
    getters,
    actions,
    mutations
}
